module.exports = __webpack_public_path__ + "img/menu.185f6c93.svg";